import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var ClickEvent = /*#__PURE__*/function () {
  function ClickEvent() {
    _classCallCheck(this, ClickEvent);

    this.enable = false;
    this.mode = [];
  }

  _createClass(ClickEvent, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.mode !== undefined) {
        this.mode = data.mode;
      }
    }
  }]);

  return ClickEvent;
}();